const _ = require("lodash");
const Config = require("./Config");
const EmailBlocker = require("./EmailBlocker");

module.exports = class AbandonedForm {
	constructor ($form) {
		this.$form = $form;
		this.config = new Config();
		this.emailBlocker = new EmailBlocker();
	}

	getId () {
		let id = window.localStorage.getItem("abandoned_form_user_id") || window.crypto.randomUUID();
		window.localStorage.setItem("abandoned_form_user_id", id);
		return id;
	}

	getBaseUrl () {
		return this.config.getIterableBackendBaseUrl();
	}

	getUrl () {
		return this.getBaseUrl() + "/wp-json/itblbackend/v1/abandoned-forms";
	}

	getForm () {
		return this.$form;
	}

	serializeFormData () {
		return _.reduce(
			this.getForm().serializeArray(),
			(data, field) => _.set(data, field.name, field.value),
			{}
		);
	}

	isValidDropOffFormData (data) {
		const email = _.get(data, "Email", "");
		return this.emailBlocker.isValidDropOffEmail(email);
	}

	async send (submittedToMarketo) {
		const formData = this.serializeFormData();

		if (!this.isValidDropOffFormData(formData)) {
			return;
		}

		try {
			await fetch (this.getUrl(), {
				method: "POST",
				headers: {
					"Content-Type": "application/json"
				},
				body: JSON.stringify({
					formData,
					id: this.getId(),
					submittedToMarketo
				}),
			});
		} catch (e) {
			console.log("AbandonedForm: Failed to auto-save");
		}
	}
}